<template>
    <div class="sl-main">
        <div class="sl-page sl-page--full">
            <div class="sl-page__header">
                <div class="sl-page__title">
                    {{ t('home.title') }}
                </div>
            </div>

            <div class="sl-page__content">
                <!-- First Line -->
                <div class="flex gap-8 w-full">
                    <shortcuts class="w-full" />

                    <orders-follow-up class="w-full" />
                </div>

                <!-- Second Line -->
                <div class="flex gap-8 mt-8 w-full">
                    <news-widget class="w-full" />

                    <notifications class="w-full" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import OrdersFollowUp from './widgets/follow-up/FollowUp.vue';
import NewsWidget     from './widgets/news/NewsWidget.vue';
import Notifications  from './widgets/notifications/Notifications.vue';
import Shortcuts      from './widgets/shortcuts/Shortcuts.vue';

const { t } = useI18n({ useScope: 'global' });
</script>
